import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKodemCi = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 55,
	height: 54,
	viewBox: "0 0 55 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M36 27.384C38.5919 27.3841 40.7354 29.7521 40.7354 32.6321V45.7522C40.7352 48.632 38.6238 51.0002 36 51.0002H18.4004C15.8085 51.0002 13.6642 48.632 13.6641 45.7522V32.6321C13.6641 29.7521 15.7764 27.384 18.4004 27.384H36ZM27.2002 3.00024C27.7121 3.00034 28.192 3.19228 28.5439 3.54419L53.2793 24.4719H53.3115C54.0155 25.1759 54.4316 26.1364 54.4316 27.1604C54.4316 27.6723 54.3355 28.1522 54.1436 28.6321C53.9516 29.1121 53.6635 29.5281 53.3115 29.8801C52.5756 30.584 51.6157 31.0002 50.5918 31.0002H48V50.4875H43.6797V26.7122H49.4395L27.2314 8.34399L5.02441 26.7122H10.8164V50.4875H6.46387V31.0002H3.9043C1.79231 31.0002 0 29.3359 0 27.2239C2.61554e-05 26.7119 0.0961134 26.1679 0.288086 25.72C0.480085 25.272 0.768155 24.8239 1.12012 24.4719L25.8555 3.54419C26.2075 3.19219 26.6882 3.00024 27.2002 3.00024ZM18.4004 31.2883C17.7284 31.2883 17.2481 31.8319 17.248 32.5999V45.72C17.2481 46.4879 17.7284 47.0315 18.4004 47.0315H36C36.6719 47.0314 37.1523 46.4879 37.1523 45.72V32.5999C37.1523 31.832 36.6719 31.2884 36 31.2883H18.4004ZM21.3438 33.9436C21.8237 33.9436 22.304 34.1358 22.624 34.5198C22.976 34.9037 23.1357 35.3838 23.1357 35.8958V42.4563C23.1357 43.0001 22.9439 43.4804 22.624 43.8323C22.272 44.2162 21.8237 44.4075 21.3438 44.4075C20.864 44.4074 20.3844 44.2159 20.0645 43.8323C19.7125 43.4484 19.5518 42.9682 19.5518 42.4563V35.8958C19.5518 35.3518 19.7445 34.8717 20.0645 34.5198C20.4163 34.168 20.864 33.9437 21.3438 33.9436ZM27.2002 33.9436C27.68 33.9437 28.1276 34.1361 28.4795 34.5198C28.7994 34.8717 28.9921 35.3838 28.9922 35.8958V42.4563C28.9921 42.9682 28.8314 43.4484 28.4795 43.8323C28.1596 44.184 27.6799 44.4074 27.2002 44.4075C26.7203 44.4075 26.2719 44.2161 25.9199 43.8323C25.6 43.4804 25.4083 42.9682 25.4082 42.4563V35.8958C25.4082 35.3838 25.568 34.9037 25.9199 34.5198C26.2399 34.1678 26.7202 33.9436 27.2002 33.9436ZM33.0879 33.9436C33.5679 33.9436 34.0162 34.1358 34.3682 34.5198C34.6881 34.8717 34.8798 35.3838 34.8799 35.8958V42.4563C34.8798 42.9682 34.7201 43.4484 34.3682 43.8323C34.0482 44.1842 33.5679 44.4075 33.0879 44.4075C32.6079 44.4075 32.1596 44.2162 31.8076 43.8323C31.4877 43.4804 31.296 42.9682 31.2959 42.4563V35.8958C31.2959 35.3839 31.4557 34.9037 31.8076 34.5198C32.1276 34.1678 32.6079 33.9436 33.0879 33.9436Z",
			fill: "url(#paint0_linear_113875_700)"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_113875_700",
			x1: 6.55196,
			y1: 15.0002,
			x2: 44.5517,
			y2: 40.5359,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .100856,
				stopColor: "#FF6868"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FEB45E"
			})]
		}) })
	]
});
const ForwardRef = forwardRef(SvgKodemCi);
export { ForwardRef as ReactComponent };
